import { render, staticRenderFns } from "./chess.vue?vue&type=template&id=2b5b5884&scoped=true&"
import script from "./chess.vue?vue&type=script&lang=js&"
export * from "./chess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b5884",
  null
  
)

export default component.exports